import { FC } from 'react'
import Button, { TProps as TButtonProps } from 'components/Button'
import styles from './FiltersButton.module.scss'

export type TProps = {
  appliedFilters?: number
  buttonElementProps?: TButtonProps
}

const FiltersButton: FC<TProps> = ({
  appliedFilters = 0,
  buttonElementProps,
}) => {
  return (
    <div className={styles.ecFiltersButton}>
      {!!appliedFilters && (
        <span
          data-testid="ecFiltersButtonCount"
          className={styles.ecFiltersButtonCount}
        >
          {appliedFilters}
        </span>
      )}
      <Button {...buttonElementProps} theme="pink">
        Filtrar
      </Button>
    </div>
  )
}

export default FiltersButton
